import React from 'react';
import { useNavigate } from 'react-router-dom';

import { BackArrowSmallIcon, ConversationsButtonIcon } from '../../../assets';
import { CampaignByIdHeaderProps } from './campaignModels';

const CampaignByIdHeader: React.FC<CampaignByIdHeaderProps> = ({
  campaignName,
  numberOfChats,
  campaignId,
}) => {
  const navigate = useNavigate();
  const handleNavigateToConversations = (campaignId: string) => {
    navigate(`/conversations/${campaignId}`);
  };
  return (
    <div className="campaign-by-id__header">
      <div className="campaign-by-id__header-title-container">
        <button
          className="campaign-by-id__header-back-button"
          onClick={() => navigate(-1)}
        >
          <BackArrowSmallIcon className="campaign-by-id__header-back-button-icon" />
        </button>
        <span className="campaign-by-id__header-title">
          {`${campaignName} Campaign`}
        </span>
      </div>
      <button
        className="campaign-by-id__header-conversations-button"
        onClick={() => handleNavigateToConversations(campaignId)}
      >
        <div className="campaign-by-id__header-conversations-button-icon">
          <ConversationsButtonIcon />
        </div>
        <span className="campaign-by-id__header-conversations-button-label">
          Conversations ({numberOfChats})
        </span>
      </button>
    </div>
  );
};

export default CampaignByIdHeader;
